var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backRoot"},[_c('i',{staticClass:"el-icon-arrow-left iconItme",staticStyle:{"width":"100%","height":"100%"},on:{"click":_vm.goBack}})])
}
var staticRenderFns = []

export { render, staticRenderFns }